import { showModalCloudflare } from "@/components/ui-feat/cloudflare";
import { track } from "@/utils/track";
import { useTranslations } from "next-intl";
import { useState } from "react";
import toast from "react-hot-toast";
import { errorCodeTrackReasonMap } from "../constants";

export enum CodeStatus {
  /** 验证码发送成功 */
  SUCCESS = 1,
  /** 验证码发送失败，黑名单用户 */
  BLACKLISTED = 2,
  /** 格式错误, */
  FORMAT_ERROR = 3,
  /** 验证码发送失败，下次需要人机验证 */
  NEED_CAPTCHA = 5,
  /** 验证码发送失败，被冻结一段时间 */
  SEND_FROZEN = 6,
}

const useCfTokenCodeStatus = () => {
  const authT = useTranslations('auth');
  const [codeStatus, setCodeStatus] = useState<CodeStatus>(CodeStatus.SUCCESS);
  const [cfToken, setCfToken] = useState<string>('');
  const errorCodeMap = {
    [CodeStatus.BLACKLISTED]: authT('errors.contactSupport'),
    [CodeStatus.FORMAT_ERROR]: authT('errors.invalidAccount'),
    // [CodeStatus.NEED_CAPTCHA]: authT('cloudflare.text1'),
    [CodeStatus.SEND_FROZEN]: authT('captcha.tooManyRequests'),
  };
  const getCfToken = async () => {
    if (codeStatus !== CodeStatus.NEED_CAPTCHA) {
      return '';
    }
    const token = await showModalCloudflare();
    setCfToken(token as string);
    return token as string;
  };
  /**
   * 
   * @param codeStatus 验证码状态
   * @param businessModel 业务模型
   * @returns 验证码是否成功发送
   */
  const checkCodeStatus = (codeStatus?: CodeStatus, businessModel: string | undefined = '找回密码') => {
    if (!codeStatus) {
      codeStatus = CodeStatus.FORMAT_ERROR;
    }
    setCodeStatus(codeStatus);
    if (codeStatus === CodeStatus.SUCCESS || codeStatus === CodeStatus.NEED_CAPTCHA) {
      track('get_verification_code_result', {
        business_model: businessModel,
        is_success: true,
      });
      return true;
    }
    if (errorCodeMap[codeStatus]) {
      toast(errorCodeMap[codeStatus]);
      track('get_verification_code_result', {
        business_model: businessModel,
        is_success: false,
        fail_reason: errorCodeTrackReasonMap[codeStatus],
      });
    }
    setCfToken('');
    return false;
  };
  return {
    errorCodeMap,
    checkCodeStatus,
    getCfToken,
    cfToken
  };
};

export default useCfTokenCodeStatus;